import { useCallback, useEffect, useMemo } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { LogOut, User, Home } from 'lucide-react'
import { useAuth } from '@/app/_components/privateRoute'
import { NavProvider } from '@/app/features/profile/NavContext'
import HeaderLogo from '@/app/layout2/HeaderLogo'
import { StickyHeaderProvider } from '@/components/raytd/sticky-header-context'
import { PageLayoutContext } from '@/app/layout2/AppLayout'
import UserMenu, { UserProfile } from '@/app/layout2/UserMenu'

const SimpleMobileLayout = () => {
    const navigate = useNavigate()
    const { logout } = useAuth()

    const handleLogout = useCallback(() => {
        logout()
        navigate('/logout')
    }, [logout, navigate])

    const handleProfileClick = useCallback(() => {
        navigate('/profile')
    }, [navigate])

    const handleHomeClick = useCallback(() => {
        navigate('/')
    }, [navigate])

    const contextValue = useMemo(() => ({
        showSidebar: false,
        showHeader: true,
        mainPageElement: null,
        isCompact: false,
        setScrollingElement: () => { }
    }), [])

    return (
        <NavProvider>
            <PageLayoutContext.Provider value={contextValue}>
                <StickyHeaderProvider>
                    <div className="flex flex-col min-h-screen w-full">
                        {/* Mobile Header */}
                        <header

                            className="z-10 w-full bg-zinc-100 border-b border-zinc-200 shadow-sm"
                        >

                            <div className="flex items-center justify-between h-16 px-4 max-w-7xl mx-auto">
                                <div className="flex items-center gap-4">
                                    <UserProfile />
                                </div>
                                <div className="flex items-center gap-4">
                                    <HeaderLogo />
                                </div>
                            </div>
                        </header>

                        {/* Main Content */}
                        <main className="flex-1 w-full bg-white">
                            <div className="max-w-7xl mx-auto px-10 py-6 text-sm">
                                Raytd currently provides only very limited features on mobile devices. For full user experience, please access it from a desktop or tablet (screen width 500px or greater).
                            </div>
                            <div className="max-w-7xl mx-auto">
                                <Outlet />
                            </div>
                        </main>

                        {/* Mobile Message Footer */}
                        <footer className="bg-white border-t border-zinc-100">
                            <div
                                className="border-primary-muted border-t rounded-md bg-primary-foreground p-4"
                            >
                                <p className="text-center text-sm font-medium text-primary">
                                    Full features available on desktop or tablet (500px+)
                                </p>
                            </div>
                        </footer>
                    </div>
                </StickyHeaderProvider>
            </PageLayoutContext.Provider>
        </NavProvider>
    )
}

export default SimpleMobileLayout

